<template lang="pug">
    // 接口回调时弹窗提示相关操作的结果
    div
      div.all-add-success(v-if="isShowTipPop",
                          :class="{tips: !showSucIcon}")
        img.suc-icon(src="../assets/img/toast_ic_success@2x.png",
                     alt="suc",
                     v-if="false")
        p.suc-tips {{PopTipsContent}}
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'popup-tips',
  computed: {
    // ...mapState('doctrans', {
    //   isShowTipPop: 'getPopTipsStatus',
    //   showSucIcon: 'getSucIconStatus',
    //   PopTipsContent: 'getPopTipsContent'
    // })
    ...mapState('doctrans', ['isShowTipPop', 'showSucIcon', 'PopTipsContent'])
  },
  watch: {
    isShowTipPop(val) {
      // console.log('val', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.all-add-success {
  background: rgba(18, 27, 52, 0.8);
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  width: 204px;
  height: 60px;
  border-radius: 6px;
  padding: 24px 0;
  @include flexCommon();
  &.tips {
    height: auto;
    .suc-tips {
      padding: 0 20px;
      line-height: 20px;
      margin: 0;
      word-break: break-all;
    }
  }
  .suc-icon {
    display: block;
    width: 32px;
    height: 32px;
  }
  .suc-tips {
    font-size: 13px;
    color: #ffffff;
    text-align: center;
    margin-top: 8px;
  }
}
</style>
